import React, { useEffect, useState } from "react"
import { Modal, ModalBody } from "reactstrap"
import { Rating } from "react-simple-star-rating"
import { displayMessage } from "helpers/misc_helpers"
import { useLoading } from "helpers/custom_hooks"
import { CreateRepairRating } from "helpers/backend_helper"

const RepairRatingModal = ({ entry, myUser }) => {
  const [ratingRequestor, setRatingRequestor] = useState(0)
  const [ratingRepairLab, setRatingRepairLab] = useState(0)
  const [show, setShow] = useState(false)
  const [error, setError] = useState()
  const setLoading = useLoading()
  const isUserRepairLab = () => myUser?.company?.id == entry?.repairLaborID
  const isUserRequestor = () => myUser?.company?.id == entry?.requestorCompanyID

  useEffect(() => {
    if (
      (entry?.statusIndex == 10 ||
        entry?.dateDeclined ||
        entry?.statusIndex == -1) &&
      ((isUserRepairLab() && !entry?.dateLaborRated) ||
        (isUserRequestor() && !entry?.dateRequestorRated))
    )
      setShow(true)
  }, [entry])

  const handleSubmit = async () => {
    try {
      setLoading(true)
      await CreateRepairRating({
        requestID: entry.id,
        ratingLabor: ratingRepairLab,
        ratingRequestor,
        type: "Repair",
      })
      window.location.reload()
    } catch (error) {
      setLoading(false)
      displayMessage("An unexpected error happened!", setError)
    }
  }

  return (
    <Modal size="sm" isOpen={show} toggle={_ => setShow(false)} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 pt-5 text-center">
          <p className="text-muted font-size-16 mb-3">
            Please provide feedback on your partner's performance
          </p>

          {!isUserRequestor() && (
            <>
              <h5 className="mt-3">Requestor Rating:</h5>
              <Rating
                onClick={rate => setRatingRequestor(rate)}
                fillClassName="text-primary"
              />
            </>
          )}
          {!isUserRepairLab() && (
            <>
              <h5 className="mt-3">Repair Lab Rating:</h5>
              <Rating
                onClick={rate => setRatingRepairLab(rate)}
                fillClassName="text-primary"
              />
            </>
          )}

          <div className="hstack gap-2 justify-content-center mb-0 mt-4">
            <button
              type="button"
              className="btn btn-outline-secondary w-100"
              onClick={_ => setShow(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-outline-primary w-100"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

export default RepairRatingModal
